module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/NextSliderButton/images/next-nav-small.17ba23d1.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/NextSliderButton/images/next-nav-small.png
// module id = 3153
// module chunks = 11